import { Outlet, Link, useLocation } from 'react-router-dom';
import './Layout.css';

function Layout() {
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path;

  return (
    <div className="layout">
      <header className="header">
        <div className="container header-inner">
          <Link to="/" className="logo">
            <span className="logo-text">GoodFetch</span>
          </Link>
          
          <nav className="nav">
            <Link 
              to="/search" 
              className={`nav-link ${isActive('/search') ? 'active' : ''}`}
            >
              Search
            </Link>
            <Link 
              to="/register" 
              className={`nav-link ${isActive('/register') ? 'active' : ''}`}
            >
              Register
            </Link>
            <Link 
              to="/remove" 
              className={`nav-link ${isActive('/remove') ? 'active' : ''}`}
            >
              Remove
            </Link>
          </nav>
        </div>
      </header>

      <main className="main">
        <Outlet />
      </main>

      <footer className="footer">
        <div className="container">
          <div className="footer-top">
            <div className="footer-brand">
              <span className="footer-logo">GoodFetch</span>
              <p className="footer-tagline">
                The Ethical AI Content Archive
              </p>
            </div>
            
            <div className="footer-links">
              <div className="footer-column">
                <h5 className="footer-heading">Navigate</h5>
                <ul>
                  <li><Link to="/search">Search Index</Link></li>
                  <li><Link to="/register">Register Site</Link></li>
                  <li><Link to="/remove">Request Removal</Link></li>
                </ul>
              </div>
              
              <div className="footer-column">
                <h5 className="footer-heading">Resources</h5>
                <ul>
                  <li>
                    <a href="https://contentsignals.org" target="_blank" rel="noopener noreferrer">
                      Content Signals
                    </a>
                  </li>
                  <li>
                    <a href="https://creativecommons.org/licenses/" target="_blank" rel="noopener noreferrer">
                      Creative Commons
                    </a>
                  </li>
                </ul>
              </div>
              
              <div className="footer-column">
                <h5 className="footer-heading">Legal</h5>
                <ul>
                  <li><Link to="/privacy">Privacy</Link></li>
                  <li><Link to="/terms">Terms</Link></li>
                </ul>
              </div>
            </div>
          </div>
          
          <div className="footer-bottom">
            <p>&copy; 2026 GoodFetch</p>
            <p>Building AI that respects creators.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Layout;
